/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M18 9c0 4.718-3.6304 8.5881-8.25 8.9692V19.25h6.3202C16.4213 17.3994 18.0472 16 20 16c2.2091 0 4 1.7909 4 4 0 2.2091-1.7909 4-4 4-1.9528 0-3.5787-1.3994-3.9298-3.25H9.1a.85.85 0 0 1-.85-.85v-1.9308C3.6303 17.5881 0 13.718 0 9c0-4.9706 4.0294-9 9-9s9 4.0294 9 9Zm2 13.5c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5-2.5 1.1193-2.5 2.5 1.1193 2.5 2.5 2.5ZM7.5373 5.4478c-.5665-.34-1.2873.0681-1.2873.7288v5.6468c0 .6607.7208 1.0688 1.2873.7289l4.7057-2.8234c.5502-.3302.5502-1.1276 0-1.4578L7.5373 5.4478Z"
    clipRule="evenodd"
  />,
  'MenuCICDFilled'
);
